





















































































import { Component, Vue, Inject, Prop, Watch, Mixins, Emit, Model } from 'vue-property-decorator'
import Emitter from 'view-design/src/mixins/emitter'
@Component
export default class CategorySelect extends Mixins(Emitter) {
  @Model('change', { type: String }) categoryId!: string
  @Prop({ type: Array, default: () => [] }) options!: any[]
  @Prop({ type: String, default: ''}) parentId!: string

  modal1: boolean = false
  selectLevel1Id: string = ''
  selectLevel2Id: string = ''
  selectLevel3Id: string = ''
  categoryDisplayName: string = ''
  currentCategory: string = ''
  currentCategoryId: string = this.categoryId
  currentItem: any = null
  get level1() {
    return this.options.filter((t) => t.level === 1)
  }
  get level2() {
    if (this.selectLevel1Id) {
      return this.options.filter((t) => t.level === 2 && t.parentId === this.selectLevel1Id)
    }
    return []
  }
  get level3() {
    if (this.selectLevel2Id) {
      return this.options.filter((t) => t.level === 3 && t.parentId === this.selectLevel2Id)
    }
    return []
  }
  @Emit('change')
  change(e) {}
  mounted() {}
  @Watch('categoryId', { immediate: true })
  valueChange(value) {
    if (value) {
      var item = this.options.find((x) => x.id === value)
      // console.log('item', item)
      if (item) {
        this.currentCategoryId = item.id
        this.currentCategory = item.fullName
        this.categoryDisplayName = item.fullName
        this.initSelected(item)
      } else {
        // 小余修改
        // 有些数据是有id，但是是无法从options找到对应的item，所以显示出来最终的id值
        this.categoryDisplayName = value
      }
    }
  }
  openModal() {
    this.modal1 = true
    this.selectLevel1Id = this.parentId
  }
  initSelected(e: any) {
    if (e) {
      this[`selectLevel${e.level}Id`] = e.id
      if (e.parent) {
        this.initSelected(e.parent)
      }
    }
  }
  ok() {
    // 判断选择的分类是否完整
    if (this.hasChildren(this.currentCategoryId)) {
      this.$Message.warning('请选择完成的分类')
      return
    }
    this.categoryDisplayName = this.currentCategory
    this.change(this.currentCategoryId)
    ;(this as any).dispatch('FormItem', 'on-form-change', this.currentCategoryId)
    this.$emit('on-change', {
      id: this.currentCategoryId,
      name: this.currentCategory,
    })
    this.modal1 = false
  }
  clearInput() {
    this.change('')
  }
  cancel() {}
  hasChildren(id: string) {
    return this.options.filter((x) => x.parentId == id).length > 0
  }
  selectCategory(level: number, e: any) {
    if (level === 1) {
      this.selectLevel2Id = ''
      this.selectLevel3Id = ''
    }
    if (level === 2) {
      this.selectLevel3Id = ''
    }
    this[`selectLevel${level}Id`] = e.id
    this.currentCategory = e.fullName
    this.currentCategoryId = e.id
    this.currentItem = e
  }
}
